import React from 'react'
import PropTypes from 'prop-types'
import { trackSlothOfDeath } from 'lib/utils/errors'
import {
  majorScale,
  Button,
  Heading,
  Image,
  Pane,
  Paragraph
} from 'evergreen-ui'
import sloth from './sloth.svg'

function handleReloadPage() {
  window.location.reload()
}

export default class ErrorPage extends React.Component {
  static propTypes = {
    error: PropTypes.shape({
      message: PropTypes.string
    })
  }

  componentDidMount() {
    if (this.props.error) {
      // Anytime we show this page (and provide an error object) we should track it
      trackSlothOfDeath(this.props.error)
    }
  }

  render() {
    return (
      <Pane display="flex" alignItems="center" justifyContent="center">
        <Pane
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          width="420px"
        >
          <Image src={sloth} alt="Segment Sloth" marginBottom={majorScale(3)} />
          <Heading size={700} marginBottom={majorScale(1)}>
            Something went wrong...
          </Heading>
          <Paragraph>
            An unexpected error occurred while loading the Segment App. We were
            notified and will try to fix it as soon as possible.
          </Paragraph>

          <Pane display="flex" marginTop={majorScale(2)}>
            <Button
              is="a"
              href="https://segment.com/contact/support"
              marginRight={majorScale(1)}
            >
              Contact Support
            </Button>
            <Button
              appearance="primary"
              intent="success"
              onClick={handleReloadPage}
            >
              Reload Page
            </Button>
          </Pane>
        </Pane>
      </Pane>
    )
  }
}
